import React, { useEffect } from "react";
import PageHero from "@/components/site/PageHero";
import { PillButton } from "@/components/site/Kit";
import { track } from "@/lib/track";

const SEEN = "nomus-booked";

// Where the calendar sends people after they book the fit call. Counts the
// booking once per browser session, and only for visitors who allowed measuring.
export default function Booked() {
  useEffect(() => {
    try {
      if (window.sessionStorage.getItem(SEEN)) return;
      window.sessionStorage.setItem(SEEN, "1");
    } catch {
      // Without storage a reload may count twice; better than not counting.
    }
    track("fit_call_booked");
  }, []);
  return (
    <>
      <PageHero
        label="Fit call"
        title="Booked."
        text="The invite is in your inbox. Twenty minutes, one job your team puts off, and a straight answer on whether an Audit makes sense."
      />
      <section className="px-5 pt-16 lg:pt-24" data-testid="booked">
        <div className="mx-auto flex max-w-[1400px] flex-col gap-6 sm:flex-row sm:items-center sm:justify-between">
          <p className="max-w-[620px] text-[20px] leading-[1.3] tracking-[-0.02em] sm:text-[26px]">
            If you have two minutes before we talk, run the check. We start the
            call from your number.
          </p>
          <PillButton to="/scorecard" size="lg">
            Start the check
          </PillButton>
        </div>
      </section>
    </>
  );
}
